module.exports = __webpack_public_path__ + "static/felecia-davis-cebe5a4ff4c836d15b6006401ecc80ff.jpg";